module.exports = __webpack_public_path__ + "static/final-54d2dae2242c70ad8d7c6c9fc7d379a3.png";